export default {
  label: 'Campañas',
  placeholder: 'Todas',
  items: {
    all: 'Todas',
    onlyScheduled: 'Solo Programadas',
  },
};
